// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import {Dispatch, MutableRefObject} from 'react';
import {SESSION_ACTIONS, t_session_action} from './sessions_reducer';
import {use_rt_data} from '../use_rt_data';
import {i_zone_session_state} from './types';
import {i_user_info} from 'hola_app_context';

interface i_ws_message {
    action: string;
    task?: any;
    task_id?: string;
    result?: any;
}

export const use_sessions_ws = (
    dispatch: Dispatch<t_session_action>,
    state_ref: MutableRefObject<i_zone_session_state>,
    user: i_user_info,
    use_sessions?: boolean,
  )=>
    {
    const ws_url = use_sessions ? `wss://${window.location.host}/ws` : null;
    const state = use_rt_data({
        ws_url,
        id: user?.hola_uid,
        on_message: (msg: i_ws_message)=>{
            if (msg.action == 'create_task' && msg.task)
            {
                dispatch({
                    type: SESSION_ACTIONS.ADD_SESSION,
                    payload: msg.task,
                });
            }
            if (msg.action == 'update_task' && msg.task)
            {
                const {sessions} = state_ref.current;
                if (sessions.some(s=>s._id == msg.task._id))
                {
                    dispatch({
                        type: SESSION_ACTIONS.UPDATE_SESSION,
                        payload: msg.task,
                    });
                }
                else
                {
                    dispatch({
                        type: SESSION_ACTIONS.ADD_SESSION,
                        payload: msg.task,
                    });
                }
            }
            if (msg.action == 'add_task_result' && msg.task_id && msg.result)
            {
                dispatch({
                    type: SESSION_ACTIONS.ADD_SESSION_RESULT,
                    payload: {
                        task_id: msg.task_id,
                        result: msg.result,
                    }
                });
            }
        },
    });
    return state;
};
